// This icon file is generated automatically.
var PShrinkOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.78.93l-.7-.7a.13.13 0 00-.18 0L8.43 2.68l-.85-.86a.12.12 0 00-.21.07L7 4.86c0 .08.06.15.14.14l2.96-.37c.1-.01.14-.14.07-.21l-.85-.85 2.46-2.47a.12.12 0 000-.17zM4.86 7l-2.96.37a.12.12 0 00-.07.21l.85.85L.22 10.9a.13.13 0 000 .17l.7.7c.06.05.14.05.18 0l2.47-2.46.85.86c.08.07.2.03.21-.07L5 7.14A.12.12 0 004.86 7z", "fill-rule": "nonzero" } }] }, "name": "p-shrink", "theme": "outlined" };
export default PShrinkOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PShrinkOutlined.js
// module id = 3637
// module chunks = 0